<div class="king-row__wrapper box-black-third hover">
  <div
    class="king-row__player king grid-item-0"
    [class.opacity-20]="
      game().king.steamid !== game().winner.steamid && game().part
    "
  >
    <app-king-user-avatar
      [isChallenger]="false"
      [kingUser]="game().king"
      [size]="2"
    ></app-king-user-avatar>
    <div class="king-row--value king">
      <app-cost
        [gap]="4"
        [cost]="game().king.value"
        [balanceType]="'skins'"
        color="var(--red)"
      />
    </div>
  </div>
  <!--  -->
  <div class="king-row--game grid-item-1">
    <span
      (click)="
        clipboardService.copy(game().gameid, 'King GameId Copy Success!')
      "
      class="king-row--game__gameid"
      >Game #{{ game().gameid }}</span
    >
    <span class="king-row--game__roundid">Round {{ game().roundid }}</span>
  </div>
  <!--  -->
  <app-skins-row
    class="king-row__skins grid-item-2"
    [skins]="skins()"
    skinSize="medium"
    (handleClick)="onClick()"
    [maxItemLength]="6"
  >
  </app-skins-row>
  <div class="king-row__fairness grid-item-3">
    <app-fairness-button
      href="/provably-fair/king/{{ game().gameid }}"
    ></app-fairness-button>
  </div>
  <div
    class="king-row__player challenger grid-item-4"
    [class.opacity-20]="
      game().part?.steamid !== game().winner.steamid && game().part
    "
  >
    @if (game().part) {
    <app-king-user-avatar
      [size]="2"
      [isChallenger]="true"
      [kingUser]="game().part || null"
    ></app-king-user-avatar>
    <div class="king-row--value challenger">
      <app-cost
        [gap]="4"
        [cost]="game().part!.value"
        [balanceType]="'skins'"
        color="var(--blue)"
      />
    </div>
    } @else {
    <span class="king-row--ran-away">KING RAN AWAY</span>
    }
  </div>
</div>
